module.exports = __webpack_public_path__ + "static/media/logo-nih-off.ffb8f18b.svg";